import React, { useState } from 'react';
import { generateSku, Regex, scrollIntoView } from '../../../utills';
import Loader from 'jd-library/Loader';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import { connect } from 'react-redux';
import { setItemErrors } from '../../../actions/items';

const SkuField = props => {
    const [skuLoader, setSkuLoader] = useState(false);

    const fillSku = () => {
        setSkuLoader(true);
        generateSku(props.token).then((res) => {
            setSkuLoader(false);
            props.setFieldValue("sku", res.data.sku);
        }).catch((error) => {
        })
    }

    return (
        <InputWithMovingLabel
            key="newsku"
            input={{
                value: props.itemInfo?.sku || "",
                onFocus: (e) => {
                    e.currentTarget && scrollIntoView(e.currentTarget,'add-edit-product');
                },
                onChange: e => {
                    if(!Regex.skuRegex.test(e.currentTarget.value)){
                        return;
                    }
                    props.updateError({ sku: '' })
                    props.setFieldValue("sku", e.currentTarget.value);
                }
            }}
            inputGroupProps={{
                rightSection: () => {
                    return (
                        <div className="sku-icons">
                            {skuLoader && <Loader />}
                            {(!skuLoader && !props.itemInfo?.sku) && <i onClick={fillSku} className="icon-Generate"></i>}
                        </div>
                    );
                }
            }}
            label="Seller SKU ID"
            holderClass={`sku-input ${props.isReadOnly ? 'read-only-mode' : ''}`}
            errorMessage={props.errors.sku}
        />
    );
};

const mapStateToProps = (state, props) => {
    return{
        ...props,
    }
}

export default connect(mapStateToProps, {
    setItemErrors
})(SkuField);